import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
  PopoverCloseButton,
  Button,
  Text,
} from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  errorMessage: string;
}

const SingleOfferErrorMessagePopover: React.FC<
  React.PropsWithChildren<Props>
> = ({ errorMessage }) => {
  const { t } = useTranslation();

  return (
    <Popover>
      <PopoverTrigger>
        <Button
          variant="link"
          color="danger.main"
          textStyle="smallBody"
          textDecoration="underline"
        >
          {t('MORE_INFO')}
        </Button>
      </PopoverTrigger>
      <PopoverContent border="none">
        <PopoverCloseButton color="whiteAlpha.900" />
        <PopoverArrow bg="gray.700" border="none" />
        <PopoverBody p="3" bg="gray.700" borderRadius="sm">
          <Text
            color="whiteAlpha.900"
            my="2"
            dangerouslySetInnerHTML={{ __html: errorMessage }}
          />
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

export default SingleOfferErrorMessagePopover;
